import { stringValue } from 'vega-util';
import { STORE, TUPLE, unitName } from '.';
import { accessPathWithDatum } from '../../util';
import { assembleInit } from './assemble';
import { TUPLE_FIELDS } from './transforms/project';
export function singleOrMultiSignals(model, selCmpt) {
  var name = selCmpt.name;
  var fieldsSg = name + TUPLE_FIELDS;
  var proj = selCmpt.project;
  var datum = '(item().isVoronoi ? datum.datum : datum)';
  var values = proj.map(function (p) {
    var fieldDef = model.fieldDef(p.channel); // Binned fields should capture extents, for a range test against the raw field.

    return fieldDef && fieldDef.bin ? "[".concat(accessPathWithDatum(model.vgField(p.channel, {}), datum), ", ") + "".concat(accessPathWithDatum(model.vgField(p.channel, {
      binSuffix: 'end'
    }), datum), "]") : "".concat(accessPathWithDatum(p.field, datum));
  }).join(', '); // Only add a discrete selection to the store if a datum is present _and_
  // the interaction isn't occurring on a group mark. This guards against
  // polluting interactive state with invalid values in faceted displays
  // as the group marks are also data-driven. We force the update to account
  // for constant null states but varying toggles (e.g., shift-click in
  // whitespace followed by a click in whitespace; the store should only
  // be cleared on the second click).

  var update = "unit: ".concat(unitName(model), ", fields: ").concat(fieldsSg, ", values");
  var signals = [{
    name: name + TUPLE,
    on: [{
      events: selCmpt.events,
      update: "datum && item().mark.marktype !== 'group' ? {".concat(update, ": [").concat(values, "]} : null"),
      force: true
    }]
  }];

  if (selCmpt.init) {
    var insert = selCmpt.init.map(function (i) {
      var str = assembleInit(i);
      return "{".concat(update, ": ").concat(str, "}");
    });
    signals.push({
      name: "".concat(name, "_init"),
      init: "modify(".concat(stringValue(selCmpt.name + STORE), ", [").concat(insert, "])")
    });
  }

  return signals;
}
var multi = {
  signals: singleOrMultiSignals,
  modifyExpr: function modifyExpr(model, selCmpt) {
    var tpl = selCmpt.name + TUPLE;
    return tpl + ', ' + (selCmpt.resolve === 'global' ? 'null' : "{unit: ".concat(unitName(model), "}"));
  }
};
export default multi;